import React from 'react';
import AdSlot, { AdSlotTargetingArguments } from './AdSlot';

interface MedrecAdSlotProps {
  adUnit: string;
  targetingArguments: AdSlotTargetingArguments;
}

export const MedrecAdSlotWidth = 300;
export const MedrecAdSlotHeight = 250;

const MedrecAdSlot: React.FC<MedrecAdSlotProps> = ({
  adUnit,
  targetingArguments,
}) => {
  return (
    <AdSlot
      adUnit={adUnit}
      size={[MedrecAdSlotWidth, MedrecAdSlotHeight]}
      targetingArguments={targetingArguments}
    />
  );
};

export default MedrecAdSlot;
